/**
 * Service institution PC page — English (nested for t('serviceInstitution.pc.…'))
 */
export default {
	joinHeader: {
		title: "Institutions Join SeerQ",
		subtitle:
			"Partner with trusted service institutions worldwide to build a compliant, reliable spiritual services ecosystem",
	},
	demo: {
		categories: {
			all: "All",
			nearby: "Nearby",
		},
		search: {
			rootTitle: "Service Institutions",
			placeholder: "Type or name",
			searchBtn: "Search",
			hotCategories: "Popular categories",
			recommendTitle: "Recommended Institutions",
			mapFullscreenAria: "Full screen",
			closeMapAria: "Close map",
			zoomInAria: "Zoom in",
			zoomOutAria: "Zoom out",
			resultTitle: "Search results",
			resultCount: "{count} results found",
			reviewCount: "{count} reviews",
			favoritesCount: "{count} favorites",
			moreBtn: "View more results",
			moreInstitutionsBtn: "View More Institutions",
			emptyResult: "No Matching Institutions Found",
			regionLoading: "Loading regions...",
		},
		detail: {
			backAria: "Back",
			defaultTip:
				"For visits or more information, please call ahead to confirm opening arrangements.",
			shareAria: "Share",
			shareCopied: "Link copied",
			shareCopyFailed: "Copy failed, please try again",
			mapBtn: "Map",
			phoneBtn: "Phone",
			phoneCopied: "Phone number copied",
			phoneCopyFailed: "Copy failed, please try again",
			hoursTitle: "Business hours",
			introTitle: "About",
			servicesTitle: "Featured services",
			reviewsTitle: "Reviews",
			viewAllReviews: "View all",
			mediaTitle: "Media",
			videoTab: "Videos {count}",
			reviewCount: "{count} reviews",
		},
		mock: {
			mapPin: [{ name: "Tsim Sha Tsui" }, { name: "Central" }, { name: "Yau Ma Tei" }],
			institution: [
				{
					name: "Jiuxiao Taoist Temple",
					type: "Taoist temple",
					address: "Shek Wu Tong Village, Kam Sheung Road, Pat Heung, Hong Kong",
					desc: "Established in 2003 (Guiwei year), mainly serves...",
					favorites: "36k favorites",
					distance: "3.6km",
				},
				{
					name: "Jiuxiao Taoist Temple",
					type: "Taoist temple",
					address: "Shek Wu Tong Village, Kam Sheung Road, Pat Heung, Hong Kong",
					desc: "Established in 2003 (Guiwei year), mainly serves...",
					favorites: "36k favorites",
					distance: "3.6km",
				},
			],
			detail: {
				title: "Kowloon Mosque",
				type: "Mosque",
				address: "670-A Jelutong Road, Jelutong, Penang",
				intro:
					"Penang Cheng Leong Keong is a Taoist temple in Jelutong, Penang, Malaysia. It enshrines Baosheng Dadi and also honors Qingshui Zushi, Shennong Dadi, Fude Zhengshen, Guanyin, and other deities.",
				tip: "For visits or more information, please call ahead to confirm opening arrangements.",
				hours: [
					{ label: "Mon–Sat", value: "08:30–17:00" },
					{ label: "Sun", value: "08:30–22:00" },
				],
				highlights: [
					{ label: "Founded: ", value: "1895" },
					{ label: "Main deity: ", value: "Baosheng Dadi" },
					{
						label: "Also enshrined: ",
						value:
							"Qingshui Zushi, Shennong Dadi, Fude Zhengshen, Guanyin, Thirty-Six Heavenly Generals, Tai Sui, Tiger General, Nezha, and Second Grand Uncle",
					},
					{ label: "Opening hours: ", value: "" },
					{ label: "", value: "Weekdays: 7:30 AM – 6:30 PM" },
					{ label: "", value: "1st & 15th of lunar month: 5:30 AM – 7:00 PM" },
				],
			},
		},
	},
};
